import React from "react";
import links from "../config/links";

function AboutSection() {
  return (
    <div>
      <div className="bottom-underline">
        <h1>About Us</h1>
      </div>
      <p className="centered-paragraph">
        Founded in 2012, the Undergraduate Bioinformatics Club (UBIC) at UCSD is
        a student-led organization dedicated to fostering a community of
        students passionate about bioinformatics. UBIC provides a space for
        students to explore their interests, develop leadership skills, and
        engage in research and networking opportunities while also forming
        lasting friendships.
      </p>
      <div style={{ marginTop: "1.5rem" }}>
        <a
          href={links.external.linktree}
          target="_blank"
          rel="noopener noreferrer"
          className="join-button"
        >
          Join Us
          <img src="/linktree_white.svg" alt="contact_logo" height="35px"></img>
        </a>
      </div>
      <section className="contact-methods">
        <div className="contact-card">
          <h3>Email</h3>
          <p>
            Have any questions or want to get involved? Contact us at
            ubic@ucsd.edu.
          </p>
          <div className="innerContact">
            <a href={`mailto:${links.external.email}`}>
              <img src="/mail_black.svg" alt="mail_logo" height="40px"></img>
            </a>
            <a
              href={`mailto:${links.external.email}`}
              target="_blank"
              rel="noopener noreferrer"
              className="contact-link"
            >
              ubic@ucsd.edu
            </a>
          </div>
        </div>
        <div className="contact-card">
          <h3>Discord</h3>
          <p>
            Join our Discord to connect with other members and stay updated on
            opportunities!
          </p>
          <div className="innerContact">
            <a href={links.external.discord}>
              <img
                src="/discord_black.svg"
                alt="discord_logo"
                height="40px"
              ></img>
            </a>

            <a
              href={links.external.discord}
              target="_blank"
              rel="noopener noreferrer"
              className="contact-link"
            >
              Join Discord
            </a>
          </div>
        </div>
        <div className="contact-card">
          <h3>Instagram</h3>
          <p>
            Follow us for news updates, Instagram Takeovers, and event
            announcements.
          </p>
          <div className="innerContact">
            <a href={links.external.instagram}>
              <img
                src="/instagram_black.svg"
                alt="insta_logo"
                height="40px"
              ></img>
            </a>
            <a
              href={links.external.instagram}
              target="_blank"
              rel="noopener noreferrer"
              className="contact-link"
            >
              @bioinformatics_at_ucsd
            </a>
          </div>
        </div>
      </section>
    </div>
  );
}

export default AboutSection;
